module.exports = __webpack_public_path__ + "img/profchecksign.56d779e8.png";